import { cn } from '@/utils'
import { StatTile, type StatTileProps } from './StatTile'

const GRID_COLS = {
  3: 'sm:grid-cols-3',
  4: 'sm:grid-cols-4',
} as const

interface StatTileGridProps {
  tiles: StatTileProps[]
  columns: keyof typeof GRID_COLS
  className?: string
}

export function StatTileGrid({ tiles, columns, className }: StatTileGridProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-1 divide-y divide-border bg-white sm:divide-x sm:divide-y-0',
        GRID_COLS[columns],
        className,
      )}
    >
      {tiles.map((tile) => (
        <StatTile key={tile.label} {...tile} />
      ))}
    </div>
  )
}
